import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSideSheetProgressBar',
  props: {
    jobStatusCount: null
  },
  setup(__props: any) {

const props = __props as {
  jobStatusCount: { name: string; count: number }[]
}


const progressBarItems = computed(() =>
  props.jobStatusCount.filter((item) => item.count > 0)
)

function getWidthPercentage(count: number) {
  const total = progressBarItems.value.reduce((acc, val) => acc + val.count, 0)
  return `${Math.floor((count / total) * 1000) / 10}%`
}

return { __sfc: true,props, progressBarItems, getWidthPercentage }
}

})